import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const LEGAL_DOCS = {
  'Tax Exemption': '/docs/BSM BHOJAN-SEVA MANDAL 80G.pdf',
  'MINISTRY OF CORPORATE AFFAIRS': '/docs/CERTIFICATE BSM BHOJAN-SEVA MANDAL FOUNDATION.pdf',
};

const getDocUrl = (label) => {
  const url = LEGAL_DOCS[label];
  if (!url) return null;
  return encodeURI(url);
};

const TIMELINE = [
  {
    month: "February",
    event:
      "NGO established with a vision to serve society through compassion, education, and community welfare.",
  },
  {
    month: "March",
    event:
      "Completed registration processes and formed the founding volunteer team.",
  },
  {
    month: "April",
    event:
      "Launched initial outreach activities and community awareness programs.",
  },
  {
    month: "May",
    event:
      "Expanded volunteer participation and initiated local support initiatives.",
  },
  {
    month: "June",
    event:
      "Strengthened partnerships and organized community engagement activities.",
  },
];

export default function About() {
  const ref = useRef(null);
  const [activeDoc, setActiveDoc] = useState(null);
  useEffect(() => { if (ref.current) ref.current.classList.add('page-enter'); }, []);

  return (
    <div ref={ref} className="pt-20">
      {/* Hero */}
      <section className="bg-amber-900 py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #f97316 0, #f97316 1px, transparent 0, transparent 40px), repeating-linear-gradient(90deg, #f97316 0, #f97316 1px, transparent 0, transparent 40px)',
            width: '100%', height: '100%'
          }} />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="font-hindi text-orange-400 text-xl mb-4">हमारे बारे में</div>
          <h1 className="font-display text-5xl md:text-6xl text-amber-50 mb-6">About Us</h1>
          <p className="text-amber-300 text-lg leading-relaxed max-w-2xl mx-auto">
            Born from the belief that no one in our community should sleep hungry, BSM Bhojan Seva Mandal Foundation has been feeding vulnerable families since 2026.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="lotus-divider text-left mb-4">🪷 🪷</div>
            <h2 className="section-title">Our Mission</h2>
            <p className="text-amber-800 text-lg leading-relaxed mb-6">
              To ensure that every person living in raw houses, construction shelters, labor camps, and unstable housing in Gujarat has access to at least one hot, nutritious meal every day — without exception, without judgment.
            </p>
            <p className="text-amber-700 leading-relaxed">
              We believe food is a fundamental right. Our volunteers operate seven days a week, 365 days a year, because hunger does not take holidays. We source fresh, locally grown ingredients and cook meals that are wholesome, hygienic, and prepared with genuine care.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="card p-6 bg-orange-600 text-white">
              <div className="text-3xl mb-3">🎯</div>
              <h3 className="font-display text-xl mb-2">Vision</h3>
              <p className="text-orange-100 text-sm leading-relaxed">A Gujarat where no vulnerable family goes hungry, and food insecurity is eradicated at the grassroots level.</p>
            </div>
            <div className="card p-6 bg-amber-800 text-white mt-8">
              <div className="text-3xl mb-3">💛</div>
              <h3 className="font-display text-xl mb-2">Values</h3>
              <p className="text-amber-200 text-sm leading-relaxed">Dignity, compassion, zero-waste, community participation, and financial transparency in all our operations.</p>
            </div>
            <div className="card p-6 bg-amber-100 col-span-2">
              <div className="text-3xl mb-3">📊</div>
              <h3 className="font-display text-xl text-amber-900 mb-2">Transparency</h3>
              <p className="text-amber-700 text-sm leading-relaxed">Every contribution is carefully used to serve freshly prepared meals to underprivileged individuals. Our priority is to ensure that maximum support reaches those struggling with daily hunger.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="lotus-divider mb-4">🪷 🪷 🪷</div>
            <h2 className="section-title">Our Journey</h2>
          </div>

          {/* Year Heading */}
          <div className="mb-12">
            <h3 className="font-display text-4xl text-orange-600 text-center">
              2026
            </h3>
          </div>

          {/* Timeline */}
          <div className="relative">
            <div className="absolute left-[94px] top-0 bottom-0 w-px bg-orange-200" />

            <div className="space-y-10">
              {TIMELINE.map(({ month, event }) => (
                <div key={month} className="flex gap-12 items-start">
                  <div className="w-16 flex-shrink-0 text-right">
                    <span className="font-display text-orange-600 text-lg">
                      {month}
                    </span>
                  </div>
              
                  <div className="relative flex-shrink-0 mt-1.5">
                    <div className="w-4 h-4 rounded-full bg-orange-500 border-4 border-orange-100 relative z-10" />
                  </div>
              
                  <p className="text-amber-800 leading-relaxed pt-0.5">
                    {event}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      {/* <section className="py-20 bg-amber-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="lotus-divider mb-4">🪷 🪷 🪷</div>
            <h2 className="section-title">Man Behind This</h2>
            <p className="section-subtitle mx-auto">The driving force behind BSM Bhojan Seva Mandal Foundation, committed to serving those in need.</p>
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 place-items-center">
      {TEAM.map(({ name, role, since, image }) => (
        <div
          key={name}
          className="card p-6 text-center hover:-translate-y-1 transition-transform duration-200 md:col-span-4 sm:col-span-2 w-full max-w-sm"
        > */}

          {/* Profile Image ONLY (removed initial circle) */}
          {/* <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-5 border-2 border-orange-400 shadow-md">
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
                <div className="font-semibold text-amber-900">{name}</div>
                <div className="text-orange-600 text-sm mt-1">{role}</div>
                <div className="text-amber-500 text-xs mt-1">{since}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Registration info */}
      <section className="py-16 bg-white border-t border-amber-100">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="section-title text-center mb-10">Legal & Registration</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[
              { label: 'Registration', value: 'Charitable Trust — Gujarat', detail: 'Reg. No. 173136' },
              { label: 'Tax Exemption', value: '80G Certified', detail: 'Reg. No. AAOCB4084GF20261' },
              { label: 'MINISTRY OF CORPORATE AFFAIRS', value: 'Certificate of Incorporation', detail: 'Identity. No. U88900GJ2026NPL' },
              // { label: 'FCRA Status', value: 'FCRA Registered', detail: 'FCRA Reg. No. 083781234' },
              { label: 'PAN', value: 'AAOCB4084G', detail: 'Income Tax India' },
              { label: 'Founded', value: '2026', detail: 'Rajkot, Gujarat' },
              { label: 'Category', value: 'Food, Nutrition & Services', detail: 'Non-Profit' },
            ].map(({ label, value, detail }) => {
              const isDoc = label === 'Tax Exemption' || label === 'MINISTRY OF CORPORATE AFFAIRS';
              return (
                <button
                  key={label}
                  type="button"
                  onClick={() => isDoc && setActiveDoc(label)}
                  className={`card p-5 text-left ${isDoc ? 'cursor-pointer hover:border-orange-300 transition-colors' : ''} ${activeDoc === label ? 'border-2 border-orange-400 bg-orange-50' : ''}`}
                  aria-label={isDoc ? `View ${value}` : undefined}
                >
                  <div className="text-xs text-amber-500 uppercase tracking-widest mb-1">{label}</div>
                  <div className="font-semibold text-amber-900">{value}</div>
                  <div className="text-sm text-amber-600">{detail}</div>
                  {isDoc && (
                    <div className="mt-3 inline-flex items-center gap-2 text-orange-600 text-sm font-medium">
                      <span>View Document</span>
                      <span>→</span>
                    </div>
                  )}
                </button>
              );
            })}
          </div>

          {/* Inline Document Viewer */}
          {activeDoc && (
            <div className="mt-8 bg-white rounded-sm border border-amber-200 shadow-lg overflow-hidden">
              <div className="flex items-center justify-between px-6 py-3 bg-amber-50 border-b border-amber-200">
                <h3 className="font-semibold text-amber-900 text-sm">
                  {activeDoc === 'Tax Exemption' ? '80G Certificate' : 'Certificate of Incorporation'}
                </h3>
                <div className="flex items-center gap-3">
                  <a
                    href={getDocUrl(activeDoc)}
                    download
                    className="text-orange-600 text-sm font-medium hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download ↓
                  </a>
                  <button
                    onClick={() => setActiveDoc(null)}
                    className="bg-orange-600 text-white px-4 py-1.5 rounded-sm hover:bg-orange-700 text-sm"
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="h-[70vh] bg-amber-50/50">
                {(() => {
                  const docUrl = getDocUrl(activeDoc);
                  if (!docUrl) return (
                    <div className="flex items-center justify-center h-full text-amber-700">
                      Document not found.
                    </div>
                  );
                  return (
                    <object
                      data={docUrl}
                      type="application/pdf"
                      className="w-full h-full"
                      aria-label="Document Viewer"
                    >
                      <div className="flex flex-col items-center justify-center h-full text-amber-700 p-6">
                        <p className="mb-4">Your browser cannot display this PDF.</p>
                        <a
                          href={docUrl}
                          download
                          className="inline-flex items-center gap-2 bg-orange-600 text-white px-6 py-2 rounded-sm hover:bg-orange-700"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download PDF ↓
                        </a>
                      </div>
                    </object>
                  );
                })()}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-orange-600 text-center">
        <h2 className="font-display text-4xl text-white mb-4">Be Part of Our Seva Family</h2>
        <p className="text-orange-100 text-lg mb-8 max-w-xl mx-auto">Become a Member, Volutneer, & spread the word — every action counts.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact" className="bg-white text-orange-600 font-semibold px-8 py-3 rounded-sm hover:bg-amber-50 transition-colors uppercase tracking-wider text-sm">
            Volunteer With Us
          </Link>
          <Link to="/membership" className="border-2 border-white text-white font-semibold px-8 py-3 rounded-sm hover:bg-orange-700 transition-colors uppercase tracking-wider text-sm">
            Join Membership
          </Link>
        </div>
      </section>
    </div>
  );
}
